import axios from "axios";
import { config } from "../config";
import { interceptor } from "../services/interceptor-service";

const API_URL = config.API_URL;

const appSignUp = (data) => {
    const payload = {
        userInfo: {
            sortKey: 'liveli',
            ...data
        }
    }; 

    return axios.post(`${API_URL}appsignup`, payload);
}

const appLogin = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }

    return axios.post(`${API_URL}applogin`, payload);
}

const getUserData = (data) => {
    interceptor.addInterceptor();
    const payload = { 
        userInfo: {
            ...data
        }
    };
    return axios.post(`${API_URL}getuserdata`, payload);
}

const forgotPassword = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }
    return axios.post(`${API_URL}forgotpasswordstartflow`, payload);
}

const forgotPasswordVerifyLink = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }
    return axios.post(`${API_URL}forgotpasswordverifylink`, payload);
}

const forgotPasswordChangePassword = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }
    return axios.post(`${API_URL}forgotpasswordchangepassword`, payload);
}

const socialLogin = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }
    return axios.post(`${API_URL}sociallogin`, payload);
}

const refreshToken = () => {
    const payload = {
        userInfo : {
            refreshToken : interceptor.getValue('refreshToken')
        }
    };
    return axios.post(`${API_URL}renew`, payload); 
}

const logOut = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }
    return axios.post(`${API_URL}signout`, payload);
}

const putBadgeColor = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }
    return axios.post(`${API_URL}putbadgecolor`, payload);
}

const getBadgeColor = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }
    return axios.post(`${API_URL}getbadgecolor`, payload);
}

const changeLiveliPassword = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }
    return axios.post(`${API_URL}changepassword`, payload);
}

const sendWelcomeEmail = (data) => {
    const payload = {
        email: {
            ...data
        }
    }
    return axios.post(`${API_URL}welcomeemail`, payload);
}

const getSettingsCredentials = () => {
    return axios.get(`${API_URL}getsettingscredentials`);
}

export default {
    sendWelcomeEmail,
    getSettingsCredentials,
    changeLiveliPassword,
    putBadgeColor,
    getBadgeColor,
    logOut,
    forgotPassword,
    forgotPasswordVerifyLink,
    forgotPasswordChangePassword,
    socialLogin,
    appSignUp,
    appLogin,
    getUserData,
    refreshToken
}